/**
 * Откуда брать картинку.
 *
 * Снятое на этом устройстве лежит рядом — показываем мгновенно и без сети.
 * Снятое коллегой или на другом телефоне приходит ссылкой на сервер: качать
 * чужие снимки на устройство заранее нельзя, ими телефон забивается за день.
 */
import type { LocalMedia } from '../db';

const urls = new Map<string, string>();

export function pictureUrl(m: LocalMedia | undefined): string | null {
  if (!m) return null;

  if (m.blob && m.blob.size > 0) {
    let u = urls.get(m.id);
    if (!u) { u = URL.createObjectURL(m.blob); urls.set(m.id, u); }
    return u;
  }
  // Сервер отдаёт файл по cookie, поставленной при входе: тег <img>
  // заголовков не шлёт, а класть снимки в открытый доступ нельзя.
  return m.serverUrl ?? null;
}

/** Освободить ссылки на локальные файлы, когда экран закрывается. */
export function releasePictures(ids?: string[]) {
  for (const [id, u] of urls) {
    if (ids && !ids.includes(id)) continue;
    URL.revokeObjectURL(u);
    urls.delete(id);
  }
}
